import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { countries, devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de ajuste'), // Label for datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Adjustment ID input
                            minWidth: 200,
                            name: 'AdjustmentId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Ajuste'), // Label for adjustment ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Ajuste'), // Placeholder text
                        },
                        {
                            view: 'text', // User ID input
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label for user ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Movement type selection
                            name: 'TypeMovement',
                            minWidth: 200,
                            label: _('Tipo del movimiento'), // Label for movement type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 'T', // Default value
                            options: [
                                {
                                    id: 'T',
                                    value: _('Todos'), // Option for all types
                                },
                                {
                                    id: 'E',
                                    value: _('Entrada'), // Option for entry
                                },
                                {
                                    id: 'S',
                                    value: _('Salida'), // Option for exit
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'richselect', // Country selection
                            minWidth: 200,
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Custom template for country options
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {},
                        {},
                        {},
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 }, // Spacer
                        {
                            view: 'button', // Button to adjust points
                            value: _('Ajustar Puntos'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('pointAdjustmentSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'prm-pointsAdjustmentsAdd',
                            click: () => {
                                webix
                                    .ui({
                                        view: 'window', // Modal window for point adjustment
                                        id: 'SubAdjustments',
                                        height: 550,
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Ajustar Puntos'), // Window title
                                                    align: 'center',
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'subform', // Form for point adjustment
                                            elements: [
                                                {
                                                    view: 'text', // User ID input in modal
                                                    label: _('Usuario Id:'),
                                                    name: 'IdUser',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    type: 'number',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'combo', // Movement type selection in modal
                                                    label: _('Tipo de movimiento:'),
                                                    name: 'TypeMovement',
                                                    id: 'TypeMovement',
                                                    required: true, // Required field
                                                    labelPosition: 'top',
                                                    options: [
                                                        {
                                                            id: 'E',
                                                            value: _('Entrada'), // Option for entry
                                                        },
                                                        {
                                                            id: 'S',
                                                            value: _('Salida'), // Option for exit
                                                        },
                                                    ],
                                                    labelWidth: 150,
                                                },
                                                {
                                                    view: 'text', // Amount of points input in modal
                                                    label: _('Cantidad:'),
                                                    name: 'AmountPoints',
                                                    id: 'AmountPoints',
                                                    type: 'number',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                    on: {
                                                        onChange: function (newVal) {
                                                            if (newVal < 0) {
                                                                webix.message({
                                                                    type: 'error',
                                                                    text: 'La cantidad no puede ser negativa.', // Error message for negative input
                                                                });
                                                                this.setValue(''); // Clear input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button', // Cancel button in modal
                                                            value: _('Cancelar'),
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close window
                                                                $$('subform').setValues(
                                                                    $$('subform').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button in modal
                                                            type: 'form',
                                                            value: _('Guardar'),
                                                            click: function ($e) {
                                                                let values = $$('subform').getValues(); // Get form values
                                                                if ($$('subform').validate()) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json',
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Report/loyaltyPoints',
                                                                            {
                                                                                ...values,
                                                                                ForUserTest: true, // Additional parameter for testing
                                                                            },
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message on failure
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var json = JSON.parse(text); // Parse response
                                                                                    if (json.HasError) {
                                                                                        webix.message({
                                                                                            title: _('¡Error!'),
                                                                                            type: 'alert-error',
                                                                                            text: json.AlertMessage, // Display error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Puntos Ajustado', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('subform').setValues(
                                                                        $$('subform').getCleanValues(), // Reset form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Close window
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Completa los campos...', // Error message for validation failure
                                                                        ),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show modal window
                            },
                        },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter', // Shortcut key
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent(
                                    'balanceAdjustments:filter',
                                    [filterdata], // Trigger filter event
                                );
                                $$('b5').collapse(); // Collapse filter section
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and attaches events.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
